import Vue from 'vue';

export default {
    async take(jackpotId) {
        return (await Vue.http.post(`/api/jackpots/take/${jackpotId}`)).data;
    },

    async getHistory(branch, skip, take) {
        return (await Vue.http.get(`/api/branches/${branch}/jackpots/history?skip=${skip}&take=${take}`)).data;
    },

    async getState(branch, currency) {
        return (await Vue.http.get(`/api/jackpots/${branch}/${currency}`)).data;
    },

    async collectJackpot(jackpotId) {
        return (await Vue.http.post(`/api/jackpots/v2/collect/${jackpotId}`)).data;
    }
}



// WEBPACK FOOTER //
// ./_common/services/jackpot.service.js